import Joi from "joi";
import {
  CONTENT_TYPES,
  SECTIONS,
  SECTION_TYPES,
  SOURCE_PAGE_TYPES,
} from "../constants";

export const userIdentified = Joi.object({
  sourceName: Joi.string()
    .valid(...Object.values(SECTIONS))
    .required(),
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
});

export const userIdentificationModalViewed = Joi.object({
  sourceName: Joi.string()
    .valid(...Object.values(SECTIONS))
    .required(),
  sourcePage: Joi.string().required(),
  sourcePageType: Joi.string()
    .valid(...Object.values(SOURCE_PAGE_TYPES))
    .required(),
  sourceElement: Joi.string()
    .valid(...Object.values(SECTION_TYPES))
    .required(),
  contentType: Joi.string()
    .valid(...Object.values(CONTENT_TYPES))
    .required(),
  id: Joi.string().required(),
  title: Joi.string().required(),
});
